// Safari only lets Web Audio start inside a tap or key press. Something that plays later on its
// own (the school bell's chime) would stay silent there, so the first tap or key press while it
// is wanted starts the audio, and later sounds can play. Listens once; returns a remover.
// win: the window. want(): whether a sound may be needed. make(): the AudioContext to start.
export function unlockOnGesture(win, want, make) {
	const evs = ["pointerdown", "keydown", "touchend"];
	const off = () => { for (const ev of evs) win.removeEventListener(ev, go, true); };
	function go() {
		if (!want()) return;
		off();
		try { const c = make(); if (c && c.state === "suspended") c.resume().catch(() => {}); } catch { /* no Web Audio */ }
	}
	for (const ev of evs) win.addEventListener(ev, go, true);
	return off;
}
